import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          最新快讯
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          网站动态与内容更新实时播报
        </p>

        <div className="max-w-2xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updatesData.map((item) => (
              <div key={item.id} className="relative mb-6 last:mb-0">
                <div className="absolute -left-[29px] top-0 w-4 h-4 rounded-full border-2 border-primary-500 bg-background-50"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-1">
                  <span className={`text-xs px-1.5 py-0.5 rounded whitespace-nowrap ${
                    item.tag === '地址更新' ? 'bg-primary-100 text-primary-600' :
                    item.tag === '新专题' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '升级' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-600'
                  }`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <p className="text-sm text-foreground-700">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}